/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_3_DescInputs */

const es_home_nexy_feature_3_desc = /** @type {(inputs: Home_Nexy_Feature_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta eventos, plazos y cronologías vinculadas a tu documentación.`)
};

const en_home_nexy_feature_3_desc = /** @type {(inputs: Home_Nexy_Feature_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query events, deadlines, and timelines linked to your documentation.`)
};

/**
* | output |
* | --- |
* | "Query events, deadlines, and timelines linked to your documentation." |
*
* @param {Home_Nexy_Feature_3_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_3_desc = /** @type {((inputs?: Home_Nexy_Feature_3_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_3_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_3_desc(inputs)
	return en_home_nexy_feature_3_desc(inputs)
});
export { home_nexy_feature_3_desc as "home.nexy.feature_3_desc" }